<template>
  <div :class="{'iphone-x': isIphoneX}">
    <down-banner
      v-if="!nocache && (product && env === 'm-web')"
      :position="'top'"
      :pageType="'product'"
      :link="'product/' + product.id"
      @close-banner="closeBanner" @banner-close="closeBanner"
    />
    <!-- <beast-header>
      <div class="detail-icon">
        <i v-show="product" class="icon" :class="favoriteClass" @click="favorite"></i>
      </div>
    </beast-header> -->

    <beast-main :class="{'down-banner': env === 'm-web' && showDownBanner}" :errorMsg="errorMsg" v-if="product && !product.invisible">
      <div class="l-detail-wrap" v-if="pageType === 'LESSON' && product">
        <lesson-product-banner :product="product" :sdk="sdk" :env="env"/>
        
        <lesson-product-info :product="product" :sdk="sdk" :env="env"/>
        <lesson-comment :comment="cmtRecommand" :sdk="sdk" :env="env" :productId="productId"/>
        <lesson-product-detail :data="detailNew" v-if="detailNew" />
        <lesson-footer :product="product" :sdk="sdk" :env="env"/>
      </div>
      <div class="p-detail-wrap" v-else>
        <product-images :nocache="nocache" :product="product" :djsformat="djsformat" @favorite="favorite"/>
        <down-payment :product="product" v-if="product"/>
        <coupons :product="product" :prodCoupons="prodCoupons" v-if="product && prodCoupons.length" @show="showCoupons"/>
        <div class="product-rc" v-if="product.matchProducts && product.matchProducts.length">
          <!-- <div class="tit">{{ product.matchProductTitle || '更多灵感' }}</div> -->
          <div class="rc-list">
            <div class="rc-wrap">
              <div class="rc-item" 
                :class="{
                  'active': curRcActive == index
                }"
                v-for="(rcProd, index) in product.matchProducts" 
                @click="goDetail(rcProd.productCode, 'rc', index, rcProd.productName)">
                <img :src="rcProd.image"/>
              </div>
            </div>
          </div>
        </div>
        <product-info :product="product" v-if="product" :fundPrice="fundPrice" @showPriceTag="showPriceTag"/>

        <select-address :product="product" />
        <labels :product="product" />
        <div class="purchase-group" v-if="product && product.groupon" @click="goPurchase(product.groupon.link)">
          <div class="title">闺蜜团开团中</div>
          <div class="summary">{{ product.groupon.number }}人组团每人只需￥{{ product.groupon.range[0] }} <span v-if="product.groupon.range[0] != product.groupon.range[1]"> - ￥{{ product.groupon.range[1] }}</span>，  快来参加吧！</div>
          <i></i>
        </div>
        <product-badges :product="product" v-if="product && product.badges && product.badges.length"/>
        <!-- <div class="end-line"></div> -->

        <detail-tab />
        <product-desc v-if="product && product.legacyDetails" :detail="detail"></product-desc>
        <product-desc-new :data="detailNew" :pageTypeImage="pageTypeImage" v-else></product-desc-new>
        <suggest v-if="!nocache" :productId="productId" :source="'PRODUCT'"/>

        <product-footer
          v-if="!nocache && !product.invisible"
          ref="pFooter"
          :env="env"
          :product="product"
          :isApp="isApp" 
          :msgCount="receiveMsgs.length || offMessageCount"
          :suggestType="suggestType"
          @showWechatGift="doShowWechatGift"
          @showMask="showDownloadMask"
          @openService="openService"
          @change="changeFund"
        />
      </div>

      <div class="tag-infos" v-if="showTagInfo && product.spvPriceInfo">
        <div class="mask"></div>
        <div class="content">
          <div class="tit">折扣明细</div>
          <div class="line"></div>
          <div class="price-step">
            <div class="info-item" v-for="priceStep in product.spvPriceInfo.priceSteps">
              <span class="name">{{priceStep.name}}</span>
              <span class="price" :style="{color: priceStep.fontColor}"><price :data="priceStep.priceChange"></price></span>
            </div>
          </div>
          <div class="line"></div>
          <div class="after-price">
            <div class="item">折后价</div>
            <div class="item price"><price :data="product.spvPriceInfo.discountPrice"></price></div>
          </div>
          <div class="line"></div>
          <div class="tip" v-if="product.spvPriceInfo.desc">{{product.spvPriceInfo.desc || ''}}</div>
          <div class="btn" @click="closeTagInfo">确定</div>
        </div>
      </div>

      <div class="coupon-wrap" v-if="showCouponList">
        <div class="mask" @click="hideCouponsList"></div>
        <div class="coupons-box">
          <div class="tit">领取优惠券</div>
          <div class="coupon-list">
            <div class="coupon-item" :class="{
              used: item.couponOwnerState !== 'ABLE'
            }" v-for="item in prodCouponsList">
              <div class="left">
                <div class="price" v-if="item.discount"><span>¥</span>{{item.discount}}</div>
                <div class="price" v-else-if="item.discountRatio">{{item.discountRatio * 10}} 折</div>
                <div class="desc">{{item.thresholdDesc}}</div>
                <div class="date" v-if="item.dateWay == 'NUMBER'">使用期限: 领取后{{item.dateNum}}天</div>
                <div class="date" v-else>使用期限: {{item.startTime | formatTime}} 至 {{item.expireTime | formatTime}}</div>
              </div>
              <div class="right" :class="{
                used: item.couponOwnerState === 'ALABLE'
              }">
                <div class="" v-if="item.couponOwnerState === 'ABLE'" @click="getCouponById(item.id)">立即领取</div>
                <div class="" v-else>立即领取</div>
              </div> 
              <img v-if="item.couponOwnerState == 'ALABLE'" src="./assets/icon-able.png" />
              <img v-if="item.couponOwnerState == 'UNABLE'" src="./assets/icon-finish.png" />
            </div>
          </div>

          <div class="action">
            <div class="btn" @click="hideCouponsList">确定</div>
          </div>
        </div>
      </div>
    </beast-main>

    <beast-main :class="{'down-banner': env === 'm-web' && showDownBanner}" :errorMsg="errorMsg" v-else-if="product && product.invisible">
       <img class="p-invisible" src="//img.thebeastshop.com/app/4.0/bg-invisible.jpeg"/>
    </beast-main>
    
    <!-- 客服 -->
    <div id="container"></div>
    <div class="mask-wrap" v-show="showDownMask" @click="showDownMask =!showDownMask ">
      <div class="arrow"></div>
      <div class="prompt">点击右上角菜单<br/>“在浏览器打开”并安装野兽派</div>
    </div>

    <!-- 2023 定制香水 -->
    <div class="qxlp-box-wrap" v-show="showQXLpBox">
      <div class="mask" @click="toggleQXLpBox"></div>
      <div class="content">
        <div class="close" @click="toggleQXLpBox"></div>
        <div class="tit">刻字服务规则须知</div>
        <div class="rule-content">
          <p>1. 目前仅支持每个输入框填写1个大写英文字母，共两个输入框可输入字符，不支持符号和表情；例如框内可分别输入：“M ”和“ L”。</p>
          <p>2. 本商品为专属定制商品，定制时我们会为您调整为合适的字体大小及位置，尽可能呈现良好的效果。实际效果以收到的实物为准；</p>
          <p>3. 确认刻字内容后一旦提交订单，不支持修改。</p>
          <p>4. 选择刻字服务的订单一经付款，即进入定制阶段，不支持无理由取消订单（即退货、退款）；</p>
          <p>5. 由于刻字工艺耗时，刻字订单将预计于付款后48小时内发货，且不为此类订单提供非质量问题的退换货服务；</p>
          <p>6. 因刻字服务需要，工作人员将打开香水瓶身的塑封包装进行刻字。外包装打开痕迹不可避免，敬请谅解。</p>
        </div>
        <div class="rule-confirm">
          <div class="chk-box" @click="checkQxlpChecked">
            <img v-show="qxlpChecked" src="//img.thebeastshop.com/app/activity/qxlp/icon-checked.png" />
            <img v-show="!qxlpChecked" src="//img.thebeastshop.com/app/activity/qxlp/icon-check.png" />
          </div>
          <div class="chk-txt">本人已阅读并同意上述规则</div>
        </div>
        <div class="action">
          <div class="btn-item" @click="confirmCustomCard(true)">确认刻字</div>
          <div class="btn-item grey" @click="confirmCustomCard">无需刻字</div>
        </div>
      </div>
    </div>
    <!-- panda gift box-->
    <gift-wechat-box 
      v-if="isShowWechatGift"
      @buyWechatGift="buyWechatGift('wechatGift')"
      @hide="isShowWechatGift = false; showWechatGiftAni = false;"
    />
  </div>
</template>

<script>
import bridge from '@beastshop/bridge'
import browser from '@beastshop/browser'
import Price from '@/price/index'
import BeastMain from '@/components/app-main/'
import BeastHeader from '@/components/app-header/'
import Suggest from '@/components/suggest-products/'
import DownBanner from '@/components/download-banner'
import queryString from 'query-string'
import wechatShare from '@/wechat-share'
import track from '@/track'
import { isIphoneX } from '@/util'
import * as simpleSemver from 'simple-semver'

import sdk from '@beastshop/sdk' 
import axios from '@beastshop/axios-m'

// product-components
import ProductImages from './components/product-images'
import Coupons from './components/coupons'
import DownPayment from './components/down-payment'
import ProductInfo from './components/product-info'
import SelectAddress from './components/select-address'
import Labels from './components/labels'
import ProductBadges from './components/product-badges'
import DetailTab from './components/detail-tab'
import ProductDescNew from './components/desc-new.vue'
import ProductDesc from './components/desc.vue'
import ProductFooter from './components/footer'

// lession-components
import LessonProductBanner from './components/lesson/product-banner.vue'
import LessonComment from './components/lesson/comment.vue'
import LessonProductDetail from './components/lesson/product-detail.vue'
import LessonProductInfo from './components/lesson/product-info.vue'
import LessonFooter from './components/lesson/footer.vue'

import GiftWechatBox from './components/gift/gift-box.vue'

import { getScrollTop, getScrollHeight, getWindowHeight } from '@/util'

import api from './api'
import util from './util'

const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

const query = queryString.parse(window.location.search)

// let __init
// if (query.productId) {
//  __init = { productId : query.productId}// test id
// }

let shareData = {
  
}

let _pending_f = false
let _rush_count_down = null

export default {
  name: 'product-detail',

  components: {
    DownBanner,
    BeastHeader,
    BeastMain,
    ProductImages,
    Coupons,
    DownPayment,
    ProductInfo,
    SelectAddress,
    Labels,
    ProductBadges,
    DetailTab,
    ProductDesc,
    ProductDescNew,
    ProductFooter,
    Suggest,
    LessonProductBanner,
    LessonComment,
    LessonProductDetail,
    LessonProductInfo,
    LessonFooter,
    GiftWechatBox,
    Price,
  },

  data () {
    return {
      productId: '',
      product: null,
      detail: null,
      detailNew: null,
      cmtRecommand: null,
      isApp: browser.app(),
      isWeixin: browser.weixin(),
      isIphoneX: isIphoneX(),
      showDownBanner: true,
      djsformat: null,
      pageType: query.pageType || '',
      pageTypeImage: query.pageType === 'image' ? true : false,
      checkNavHeight: (clientWidth/375)*3,
      showTagInfo: false,
      errorMsg: '',
      prodCoupons: [],
      prodCouponsList: [],
      showCouponList: false,
      sdk: {},
      nocache: query.nocache == 'true' ? true : false,
      env: 'm-web',
      fundPrice: [],
      zcInit: false,
      receiveMsgs: [],
      offMessageCount: 0,
      suggestType: decodeURIComponent(query.suggestType || ''),
      showDownMask: false,
      isShowWechatGift: false,
      curRcActive: 0,
      showQXLpBox: false,
      category: null,
      custData: {},
      qxlpChecked: false,
      initPage: false,
      title: '加载中...'
    }
  },

  created () {
    this.productId = this.getProductId()

    sdk.init({
      vue: this
    })
    
    getEnv()
    .then(sdk => {
      this.sdk = sdk
      this.env = this.sdk.adapter.env

      this.init()
    })
    sessionStorage.removeItem('_cards')
  },

  mounted () {
    this.getMember()
    .then(data => {
      setTimeout(() => {
        this.loadService(data)
      }, 300)
    })
  },

  computed: {
    favoriteClass: function() {
      return this.product && this.product.favorited ?
        'icon-like-active' :
        'icon-like'
    }
  },

  provide() {
    return {
      toggleQXLpBox: this.toggleQXLpBox,
    }
  },

  methods: {
    init () {
      this.$setTitle('')
      this.$showLoading()
      if (this.pageType === 'LESSON') {
        this.getLessonDetail()

        window.onscroll = () => {
          const scrollTop = getScrollTop()

          if(this.checkVersion()) {
            if (scrollTop >= this.checkNavHeight) {
              this.setNav('活动详情', {
                shadowColor: '#ffffff',
                bgColor: '#ffffff'
              })
            } else {
              this.setNav('', {
                shadowColor: '#ffffff',
                bgColor: '#ffffff'
              })
            }
          }
        }
      }
      else {
        this.getProductDetail()
      }
    },
    
    setNav (title, opts) {
      this.$setTitle(title)
      
      if (browser.app()) {
        bridge.setNavigation(opts)
      }
    },

    changeFund (funds) {
      this.fundPrice= funds
    },

    showCoupons (prodCouponsList) {
      this.showCouponList = true
      this.prodCouponsList = prodCouponsList

      document.body.style.overflow = 'hidden'
    },

    confirmCustomCard (type) {
      const {
        custData
      } = this

      if (type == true && !this.qxlpChecked) {
        this.$toast('请先勾选规则须知')
        return
      }

      const query = `spvId=${custData.spvId}&orderType=${custData.orderType}&count=${custData.count}&type=edit&source=detail`

      if (type == true) {
        if (this.isApp) {
          // window.location.href = `beastapp://entry?name=qx-lp&${query}`
          bridge.open({
            url: `beastapp://entry?name=qx-lp&${query}`
          })
        }
        else {
          window.location.href = `/activity/qxlp?${query}`
        }
      }
      else {
        if (browser.app()) {
          bridge.open({
            url: 'beastapp://order',
            data: custData.orderData
          })
        }
        else {
          sessionStorage.orderData = JSON.stringify(custData.orderData)
          window.location.href = '/order'
        }
      }
    },

    checkQxlpChecked () {
      this.qxlpChecked = !this.qxlpChecked
    },

    toggleQXLpBox (id, count, orderType, orderData) {
      this.showQXLpBox = !this.showQXLpBox
      this.custData = Object.assign({}, {
        spvId: id,
        count,
        orderType,
        orderData
      })
    },

    getScrollW (index) {
      this.contentScrollW = document.querySelector('.rc-list').clientWidth
      const item = document.querySelectorAll('.rc-item')
      const category = []
      for (const n in item) {
        category.push({
          left: item[n].offsetLeft,
          width: item[n].clientWidth
        })
      }
      this.category = category

      const ele = document.querySelector('.rc-list')
        // this.product = null
      ele.scrollLeft = this.category[index].left - this.contentScrollW / 2 + this.category[index].width / 2
    }, 

    goDetail (code, type, index, pname) {
      if (type === 'rc') {
        clearTimeout(_rush_count_down)
        sa.track('MoreColourStyleClick', {
          MoreColourStyle_mainprodcode: this.productId,
          MoreColourStyle_mainprodname: this.product.name,
          MoreColourStyleClick_prodcode: code,
          MoreColourStyleClick_prodname: pname
        })

        const ele = document.querySelector('.rc-list')
        
        // this.product = null
        this.productId = code
        this.djsformat = null
        this.curRcActive = index
        this.init()

        this.$nextTick(() => {
          ele.scrollLeft = this.category[index].left - this.contentScrollW / 2 + this.category[index].width / 2
        })
        return
      }
      window.location.href = `/product/${code}`
    },

    getCouponById (couponid) {
      const _TYPE = {
        'CHEAPEN_LINE': '满减',
        'DISCOUNT_LINE': '折扣',
        'FIXEDPRICE_LINE': '定价'
      }

      let _range = ''

      const {
        id
      } = this.product
      this.$ensureLogged()
      .then(() => {
        api.getCouponByCode(couponid, id)
        .then(({ data }) => {
          this.$toast('领取成功,优惠券可至个人中心-我的卡券查')

          if (data.discountType === 'CHEAPEN_LINE') {
            _range = `减${data.discount}元`
          }
          else if (data.discountType === 'DISCOUNT_LINE') {
            _range = `打${data.discountRatio * 10}折`
          }
          else {
            _range = `定价${data.discount}元`
          }

          sa.track('ReceiveDiscount', {
            discount_id: couponid,
            discount_name: data.title,
            discount_type: _TYPE[data.discountType],
            discount_amount_range: _range
          })

          this.getLists()
          // this.getProdCoupons(this.product)
        })
        .catch(err => {
          this.$toast(err.message)
        })
      })
    },

    getLists () {
      const {
        productId,
        id
      } = this.product

      api.getCouponsByProduct(id, productId, true)
      .then(({ data }) => {
        this.prodCouponsList = data
        this.showCouponList = true
      })
    },

    hideCouponsList () {
      this.showCouponList = false
      document.body.style.overflow = 'auto'
    },

    getProdCoupons (product) {
      const {
        productId,
        id
      } = product

      api.getCouponsByProduct(id, productId, false)
      .then(({ data }) => {

        if (!data.length) return

        this.prodCoupons = data
      })
    },

    getProductDetail () {
      api.getProduct(this.productId, query.source)
      .then(({
        data
      }) => {
        let rcIndex = 0
        if (data.matchProducts && data.matchProducts.length) {
         
          data.matchProducts.forEach((pro, ind)=> {
            if (pro.productCode === this.productId) {
              rcIndex = ind
            }
          })

          sa.track('MoreColourStyleExposure', {
            MoreColourStyle_mainprodcode: this.productId,
            MoreColourStyle_mainprodname: data.name,
          })
        }

        this.curRcActive = rcIndex
        const _init = this.initPage

        this.$hideLoading()
        this.renderData(data)
        this.getProdCoupons(data)
        this.initPage = true

        this.$nextTick(() => {
          if (!_init && rcIndex > 0) {
            this.getScrollW(rcIndex)
          }
          else if (!this.curRcActive) {
            this.getScrollW()
          }
        })

        sa.setCurrentPageWithOutRefer('商品详情页', `商品详情页:${data.name}`, this.productId)
      
        sa.track('CommodityDetail', {
          ...sa.getReferPageName(),
          commodity_spu_id: this.productId,
          commodity_name: data.name,
          activity_type: sa.getActivity(data.labels),
          hot_label: [],
          original_price: data.rawPrice,
          discount_price: data.price,
          commodity_need_point: data.pointPrice || 0
        })

        sa.setCurrentPage('商品详情页', `商品详情页:${data.name}`, this.productId)

      })
      .catch(err => {
        this.$hideLoading()
        this.errorMsg = err.message || '系统异常'
        this.$alert(this.errorMsg)
      })
    },

    getLessonDetail () {
      api.getLessonDetail(this.productId)
      .then(({ data }) => {
        this.product = data

        api.getDetail(this.productId, false)
        .then(({
          data
        }) => {
          this.detailNew = data
        })
        .catch(err => {})

        if (browser.app()) {
          this.initAppShare(data.share)
        }
        else if (this.isWeixin){
          this.initWechatShare(data, this.pageType)
        }

        this.getComment()
        
        this.$nextTick(() => {
          this.$hideLoading()
        })
      })
      .catch(err => {
        this.$hideLoading()
        this.errorMsg = err.message || '系统异常'
      })      
    },

    checkVersion () {
      const version = browser.app() ? browser.app().version : ''

      if(browser.app() && version && simpleSemver.gte(version, '3.6.0')) {
        return true
      } else {
        return false
      }
    },

    showPriceTag (flag) {
      this.showTagInfo = flag
    },

    closeTagInfo () {
      this.showTagInfo = false
    },

    getComment () {
      api.getCommentBy({
        productCode: this.productId,
        increase: 0,
        scene: 'BEAST_CLASS'
      })
      .then(({ data }) => {
        if (!data.items.length) return

        const type = data.items[0].annex.type
        let items = []
        data.items.some(item => {
          if(type === 'NONE') {
            items.push(item)
            return true
          }

          if(item.annex.type === 'VIDEO' || item.annex.type === 'IMAGE') {
            items.push(item)
          }
        })

        this.cmtRecommand = {
          type,
          items: items
        }

        console.log(this.cmtRecommand, "cmtRecommend")
      })
    },

    renderData (data) {
      // if (!this.nocache && this.unShow(data)) {
      //   return this.$alert("商品已下架")
      //   .then(() => {
      //     location.href = process.env.WEBFRONT_URL
      //   })
      // }

      if(data.downPayment && !data.downPayment.show) {//预付定金不展示 相当于该商品不是预付定金商品
        data.downPayment = null
      }
      if(data.downPayment) {//格式化 抵扣金额
        let deductionFlag = true
        let priceSingle = true
        let price = 0
        let deductionSingle = true
        let deduction = 0
        let finalSingle = true
        let final = 0
        let tips = []

        const downPayment = data.downPayment
        const details = downPayment?downPayment.details:[]
        details.forEach(d => {
          if(!d.deduction) {
            deductionFlag = false
          }
          
          if(price == 0) {
            price = d.price
          }
          if(price && price !== d.price) {
            priceSingle = false
          }
          if(deduction == 0) {
            deduction = d.deduction
          }
          if(deduction !== 0 && deduction !== d.deduction) {
            deductionSingle = false
          }
          if(final == 0) {
            final = d.finalPrice
          }
          if(final !== 0 && final !== d.finalPrice) {
            finalSingle = false
          }

          if(d.tip) {
            tips.push(d.tip)
          }
        })
        data.downPayment.deductionFlag = deductionFlag
        data.downPayment.priceSingle = priceSingle
        data.downPayment.deductionSingle = deductionSingle
        data.downPayment.finalSingle = finalSingle
        if(tips.length) {
          data.downPayment.tips = tips
        }

        const discount = data.downPayment.discount
        if(discount) {
          let coupons = discount.coupons
          if(coupons && coupons.length > 3) {
            coupons = coupons.slice(0, 3)
          }
          data.downPayment.discount._coupons = coupons
        }
      }
      util.clean(data)

      const _priceTags = []
      const _stockWarn = []
      data.variant.spvs.forEach(spv => {
        if (spv.priceTags && spv.priceTags.length) {
          _priceTags.push({
            priceTags: spv.priceTags,
            priceInfo: spv.priceInfo
          })
        }
        _stockWarn.push(spv.stockWarn || '')
      })

      if (_priceTags.length) {
        const _tag = _priceTags[0]
        data.spvPriceTag = _tag.priceTags
        data.spvPriceInfo = _tag.priceInfo
      }

      if (_stockWarn.length) {
        data.spvStockWarn = _stockWarn[0]
      }

      this.product = data
      
      this.$setTitle(data.brand && data.brand.name)

      if (data._rush && data._rush._djs) {
        this.getCountDown()
      }

      if (this.nocache) {
        setTimeout(() => {
          this.closeBanner()
        }, 300);
      }

      api.getDetail(this.productId, this.product.legacyDetails, query.nocache)
      .then(({
        data
      }) => {
        this.$hideLoading()
        if (!this.product.legacyDetails) {
          this.detailNew = data
        } else {
          data.forEach(util.cleanDetail)
          this.detail = data
        }
      })
      .catch(err => {})

      if (this.isWeixin) {
        this.initWechatShare(data)
      }
    },

    initWechatShare (data, pageType = '') {
      wechatShare({
        title: `${data.share.title}`,
        content: `${data.share.content}`,
        link: `${process.env.M_DOMAIN}/product/${data.id ? data.id : data.productCode}?pageType=${pageType}`,
        success: channel => {
          track({
            name: 'product-share-success',
            attrs: {
              channel
            }
          })
          this.shareNoticeAction()
        }
      })
    },

    initAppShare (data) {
      if (data) {
        data.link = `${process.env.M_DOMAIN}/product/${this.productId}?pageType=${this.pageType}`
      }
      bridge.setButtons('RT', [{
        type: 'SHARE',
        handle: () => {
          track({
            name: 'lesson-share',
          })
          bridge.share(data, () => {
            this.shareNoticeAction()
          })
        }
      }], () => {})
    },

    getProductId () {
      let productId  = ''

      // productId = query.productId
      if (this.isApp) {
        productId = query.productId
      } else {
        productId = query.productId?query.productId:__init.productId
      }

      return productId
    },

    unSale () {
      const _product = this.product
      return _product.soldOut ||
        !_product.buyable ||
        _product.offShelf
    },

    goPurchase (link) {
      const query = link.split('?')[1]
      window.location.href = `/group/purchase?${query}`
    },

    favorite () {
      if (_pending_f) return

      _pending_f = true

      let _tip = this.product.favorited ? '取消收藏' : '收藏'
      this.$ensureLogged()
      .then(() => {
        track({
          name: 'product-favorite',
          attrs: {
            value: !this.product.favorited
          }
        })
        let _type = this.product.favorited ? 'DELETE' : 'POST'
        let _saType = _type === 'POST' ? 'CollectCommodity' : 'CancelCollectCommodity'
        
        sa.track(_saType, {
          commodity_spu_id: this.product.id,
          commodity_name: this.product.name,
          original_price: this.product.rawPrice,
          discount_price: this.product.price
        })
        
        api.favorite(this.productId, _type)
        .then(() => {

          this.$toast(`${_tip}成功`)
          this.product.favorited = !this.product.favorited
          _pending_f = false
        })
        .catch(() => {
          this.$toast(`${_tip}失败`)
          _pending_f = false
        })
      })
      .catch(() => {
        _pending_f = false
      })
    },

    buyWechatGift () {
      this.$refs.pFooter.tapBuy('wechat-gift')
    },

    getCountDown () {
      let endDate = new Date(this.product._rush._djs),
          _now = new Date()

      let leftTime = endDate.getTime() / 1000 - _now.getTime() / 1000,
        leftsecond = parseInt(leftTime),
        day1 = Math.floor(leftsecond / (60 * 60 * 24)),
        hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600),
        minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60),
        second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60)
      hour += day1 * 24
      if (hour == 0 && minute == 0 && second == 0) {
        this.djsformat = null
        clearTimeout(_rush_count_down)
        return false
      }

      if (day1 > 0) {
        const h = hour - day1 * 24
        this.djsformat = `${day1}天 ${h < 10 ? `0${h}`:h}:${minute < 10 ? `0${minute}`: minute}:${second < 10 ? `0${second}`:second}`
      }
      else {
        this.djsformat = `${hour < 10 ? `0${hour}`: hour}:${minute < 10 ? `0${minute}`: minute}:${second < 10 ? `0${second}`:second}`
      }
      
      _rush_count_down = setTimeout(() => {
        this.getCountDown()
      }, 1000);
    },

    unShow (data) {
      const _product = data

      return _product.invisible
    },

    closeBanner () {
      this.showDownBanner = false
    },

    shareNoticeAction () {
      api.shareNotice(this.productId)
      .then(data => {})
      .catch(err => {
        console.log(err || 'shareNoticeAction出错啦')
        return
      })
    },
    openService () {
      if (this.zcInit) return
    
      this.$ensureLogged()
      .then(data => {
        this.loadService(data)
      })
    },

    openZC () {
      this.zc.expand()
    },

    doShowWechatGift () {
      this.isShowWechatGift = !this.isShowWechatGift
    },

    checkMember () {
      this.getMember()
      .then(data => {
        if(!data) {
          if(loginFlag) {
            return
          }
          this.$ensureLogged((status) => {
            loginFlag = true
            if(status.alreadyLogged || status.logged) {
              this.checkMember()
            }
          })
          .catch(err => {
            return
          })
        } else {
          this.loadService(data)
        }
      })
      .catch(err => {
        console.log(err, "getMember出错啦")
      })
    },

    getMember () {
      return axios({
        url: '/app/member',
        method: 'GET',
      })
      .then(({
        code,
        data
      }) => {
        return Promise.resolve(data)
      })
      .catch(err => {
        return Promise.reject(err)
      })
    },

    showDownloadMask () {
      this.showDownMask = true
    },

    loadService (data) {
      const memberId = data ? data.memberId : ''
      this.createInstance(memberId)
    },

    createInstance (memberId) {
      const _self = this;

      (function (w, d, e, x) { 
        w[e] = function () {
          w.cbk = w.cbk || [];    
          w.cbk.push(arguments); 
        }  
        x = d.createElement('script');
        x.async = true;
        x.id = 'zhichiScript';
        x.className='service';
        x.src = 'https://www.sobot.com/chat/frame/v2/entrance.js?sysnum=46d89a7a70354f90bc09728734838699';
        d.body.appendChild(x);
      })(window, document, 'zc');

      zc('config',{
        custom:true, //设置自定义生效 第二步
        partnerid: memberId
      })

      zc("frame_manual", function (res) {
        _self.zcInit = true
      })

      // zc('receive_message', res => {
      //   _self.receiveMsgs = res
      // })

      // zc('offline_message_count', res => {
      //   if (!res) return
      //   _self.offMessageCount = res.size
      // })
    }
  },

  filters: {
    formatTime(time) {
      const date = new Date(time)
      let year = date.getFullYear()
      let month = date.getMonth() - 0 + 1
      let day = date.getDate()

      if (month < 10) {
        month = `0${month}`
      }
      if (day < 10) {
        day = `0${day}`
      } 

      return `${year}-${month}-${day}`
    }
  }
}

function getEnv () {
  return new Promise((resolve, reject) => {
    sdk.adapter.invoke(function () {
      resolve(sdk)
    })
  })
}
</script>

<style lang="stylus">
@import './index.styl'
</style>





// WEBPACK FOOTER //
// index.vue?a2e70f6c